import Vue from 'vue';
import productFlowTransformer from './../../transformers/productFlow';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentproductFlow', productFlowTransformer.fetch(data));
  resolve(productFlowTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(productFlowTransformer.fetch(errors));
};

export default (id, productFlow) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/productflow/${id}`, productFlow)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productFlow/update.js